import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { canDirective } from '@/directives/can'
import { revealDirective } from '@/directives/reveal'
import { useSettingsStore } from '@/stores/settings'
import { useAuthStore } from '@/stores/auth'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import '@/assets/styles/style.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.directive('can', canDirective)
app.directive('reveal', revealDirective)

// Load global settings (currency, branding) before first paint.
useSettingsStore().load()

// Refresh the session (and its permission snapshot) from the server before the
// first paint so a persisted token never renders the UI against a stale set of
// permissions — otherwise newly granted permissions stay invisible until the
// user manually logs out and back in.
async function boot() {
  const auth = useAuthStore()
  if (auth.isAuthenticated) {
    try {
      await auth.fetchCurrentUser()
    } catch {
      // A 401 is already handled by the http interceptor (logout + redirect).
    }
  }
  app.mount('#app')
}

boot()
